export const LOADER = '[Loader]';

export const SET_LOADER = `${LOADER} SET_LOADER`;
